import { Injectable, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { tap }         from 'rxjs/operators';
import { env } from 'process';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor( private _http: HttpClient, private _router: Router ) { }

  @Output() getLoggedIn: EventEmitter<any> = new EventEmitter();

  refreshTokens(){
    const httpOptions = {
      headers: new HttpHeaders({'RefreshToken': 'Bearer ' + this.refreshToken})
    };
    return this._http.get<any>(environment.api+'/api/users/token', httpOptions).pipe(
      tap((res)=> {
        if(res.status){
          this.saveAccessToken(res.accessToken);
          this.saveRefreshToken(res.refreshToken);
        }
      })
    );
  }

  saveAccessToken(accessToken: string){
  	if(window.localStorage){
      localStorage.setItem('accessToken', accessToken);
      this.getLoggedIn.emit('loggedIn');
  	}
  }

  saveRefreshToken(refreshToken: string){
    if(window.localStorage)
      localStorage.setItem('refreshToken', refreshToken);
  }

  login(loginInfo: any){
    const httpOptions = {
      headers: new HttpHeaders({'X-Skip-Interceptor':  'true'})
    };
    return this._http.post<any>(environment.api+'/api/users/userlogin', loginInfo, httpOptions);
  }

  logOut(){
    const httpOptions = {
      headers: new HttpHeaders({'RefreshToken': 'Bearer ' + this.refreshToken})
    };
    return this._http.get<any>(environment.api+'/api/users/logout', httpOptions)
  }

  verifyUserPhone(accessToken, code){
    let params = new HttpParams({
      fromObject: {
        code: code
      }
    })
    const httpOptions = {
      headers: new HttpHeaders({'Authorization': 'Bearer ' + accessToken, 'X-Skip-Interceptor':  'true'})
    };
    return this._http.post<any>(environment.api+'/api/verifyphone/checkcode', params, httpOptions)
  }

  sendOTP(accessToken){
    const httpOptions = {
      headers: new HttpHeaders({'Authorization': 'Bearer ' + accessToken, 'X-Skip-Interceptor':  'true'})
    };
    return this._http.get<any>(environment.api+'/api/verifyphone/verify-again', httpOptions)
  }

  requestPasswordChange(phone){
    let params = new HttpParams({
      fromObject: {
        phone: phone
      }
    })
    return this._http.post<any>(environment.api+'/api/users/request-password-change', params)
  }

  requestPasswordChangeToken(phone, otp){
    let params = new HttpParams({
      fromObject: {
        phone: phone,
        code: otp
      }
    })
    return this._http.post<any>(environment.api+'/api/users/password-change-token', params)
  }

  clearStorage(){
    if(window.localStorage){
      localStorage.clear();
      this.getLoggedIn.emit('loggedOut');
    }
    this._router.navigate([''])
  }

  get refreshToken(){
    if(window.localStorage){
      let tokenValue = localStorage.getItem('refreshToken');
      return tokenValue;
    }
    return null;
  }

  get accessToken(){
  	if(window.localStorage){
  		let tokenValue = localStorage.getItem('accessToken');
  		return tokenValue;
    }
    return null;
  }


  changePassword(newPassword, oldPassword){
    let params = new HttpParams({
      fromObject: {
        newPassword: newPassword,
        oldPassword: oldPassword
      }
    })
    return this._http.put<any>(environment.api+'/api/users/change-password', params)
  }

  changePasswordWithToken(password, token){
    const httpOptions = {
      headers: new HttpHeaders({'X-Skip-Interceptor':  'true', 'Authorization': 'Bearer ' + token})
    };
    let params = new HttpParams({
      fromObject: {
        password: password
      }
    })
    return this._http.post<any>(environment.api+'/api/users/change-password-with-token', params, httpOptions)
  }

  changePhoneNumber(phone){
    let params = new HttpParams({
      fromObject: {
        phone: phone
      }
    })
    return this._http.put<any>(environment.api+'/api/users/change-phone', params)
  }

  checkEsewaPayment(paymentParams){
    const httpOptions = {
      headers: new HttpHeaders({'X-Skip-Interceptor':  'true' }),
      params: new HttpParams({ fromObject: paymentParams }),
      observe: 'response' as const,
      responseType: 'text' as const
    };
    return this._http.request('get',environment.esewa+'/epay/transrec', httpOptions)
  }

  savePaymentDetails(details){
    let formData = new FormData()
    for(let key in details){
      formData.append(key, details[key])
    }
    return this._http.post<any>(environment.api+'/api/transactions/add', formData)
  }

  updatePaymentDetails(id, details){
    let formData = new FormData()
    for(let key in details){
      formData.append(key, details[key])
    }
    return this._http.post<any>(environment.api+'/api/transactions/edit/'+id, formData)
  }

}
